import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";

interface NotesFieldProps {
  notes: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const NotesField = ({ notes, onChange }: NotesFieldProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1">
        {t("companies.createModal.notesLabel")}
      </label>
      <Textarea
        id="notes"
        value={notes}
        onChange={onChange}
        rows={3}
      />
    </div>
  );
};
